import unicomDialog from './unicomDialog'
import LeaveDialog from './LeaveDialog'
import paymentmask from './paymentmask'
import protocol from './protocol'
import progress from './progress'
import svgIcon from './svgIcon'

const components = [
  unicomDialog,
  LeaveDialog,
  paymentmask,
  protocol,
  progress,
  svgIcon
]

components.forEach(item => {
  item.install = (Vue) => {
    Vue.component(item.name, item)
  }
})

const adminModule = (Vue) => {
  components.forEach(component => {
    Vue.use(component)
  })
}

export {
  adminModule
}
